module.exports = __webpack_public_path__ + "static/media/invite-3.4759c3ed.jpeg";